import type { TierBadgeDto } from '@schwrz/shared';

/** Legacy defaults when tier overrides are not loaded yet. */
export const DEFAULT_TIER_EMOJIS = ['⚪', '🥉', '🥈', '🥇'] as const;

export function tierEmojiForIndex(tierIndex: number, tiers: TierBadgeDto[]): string {
  const row = tiers.find((t) => t.tierIndex === tierIndex);
  if (row?.emoji) return row.emoji;
  return DEFAULT_TIER_EMOJIS[tierIndex] ?? '⚪';
}
